export default "__VITE_PUBLIC_ASSET__91dcc254__"